import { ConfirmAction } from './interface';
import { Api } from '$api';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { toastActions } from '$store/toast';
import { confirmActions, confirmSelector } from '$store/confirm/index';

function* confirmWorker(action: ConfirmAction) {
  const confirmCode = action.payload;
  const { requestConfig, confirmationControls } = yield select(confirmSelector);

  try {
    if (confirmCode) {
      const data = yield call(Api.request, {
        ...requestConfig,
        data: JSON.stringify({
          ...JSON.parse(requestConfig?.data),
          confirmCode,
        }),
      });
      yield call(confirmationControls?.resolve, data);
    } else {
      yield call(confirmationControls?.reject, {
        message: 'Code is required',
      });
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }

  yield put(confirmActions.reset());
}

export function* confirmSaga() {
  yield all([takeEvery(confirmActions.confirm, confirmWorker)]);
}
